import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {AddFileAttachmentsParams} from "../types/AddFileAttachmentsParams";

export async function apiAddFileAttachment(params: AddFileAttachmentsParams): Promise<ApiResult> {
	try {
		return await apiClient.post("document", params);
	}
	catch (error) {
		return {
			isSuccess: false,
			errorMessage: "Error when adding the file attachment: " + error
		};
	}
}
